import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

/**
 * A stored phone number grouped the way its country writes it:
 * "+12068473291" -> "+1 206 847 3291", "+40712345678" -> "+40 712 345 678".
 *
 * A value that cannot be parsed is returned as stored, rather than guessed at.
 */
export const formatPhoneNumber = (
  phone?: string | null
): string | undefined => {
  if (!phone) {
    return undefined;
  }

  return parsePhoneNumberFromString(phone)?.formatInternational() ?? phone;
};
